import { callable } from '../callable';

export interface ZoomIntegrationStateDto {
  configured: boolean;
  accountId: string | null;
  clientId: string | null;
  status: string;
  lastSyncAt: string | null;
  lastSyncError: string | null;
  courseHostMap: Record<string, string> | null;
}

export const zoomApi = {
  getState: async (data: { tenantId: string }): Promise<ZoomIntegrationStateDto> => {
    const fn = callable<typeof data, ZoomIntegrationStateDto>('getZoomIntegrationState');
    return (await fn(data)).data;
  },
  configure: async (data: {
    tenantId: string;
    accountId: string;
    clientId: string;
    clientSecret: string;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('configureZoomIntegration');
    return (await fn(data)).data;
  },
  revoke: async (data: { tenantId: string }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('revokeZoomIntegration');
    return (await fn(data)).data;
  },
  setCourseHost: async (data: {
    tenantId: string;
    courseId: string;
    zoomUserId: string;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('setZoomCourseHost');
    return (await fn(data)).data;
  },
  syncNow: async (data: {
    tenantId: string;
  }): Promise<{ meetingsFound: number; materialsCreated: number }> => {
    const fn = callable<typeof data, { meetingsFound: number; materialsCreated: number }>(
      'syncZoomRecordingsForTenant',
    );
    return (await fn(data)).data;
  },
};
